<div class="sku-locations-container">
  <div class="sku-locations-header">
    <h2 class="sku-locations-title">SKU Locations</h2>
  </div>

  <div class="buttons-search-wrapper">
    <div class="search-rule">
      <gains-input
        class="width-input"
        [required]="false"
        placeholder="Search SKU Locations..."
        icon="assets/icons/search.svg"
        [(ngModel)]="searchInputValue"
        (ngModelChange)="onSearchRuleChange($event)"
      ></gains-input>
    </div>
    <div class="button-container">
      <gains-column-management [getCurrentColDefs]="getCurrentColDefs" [gridComponent]="gainsGrid"> </gains-column-management>
    </div>
  </div>
  <gains-filter-bar [gridApi]="this.gridApi" [colDefs]="columnDefs" (filterChanged)="this.filterBarChanged()"> </gains-filter-bar>

  <!-- Tab structure is not needed in Phase 1 since the 'Selected SKU Locations' Tab will not be developed in phase 1  
  <gains-tabset [styleType]="'Card'" [(selectedIndex)]="activeTabIndex">
    <gains-tab [title]="'All SKU Locations'"> </gains-tab>
    <gains-tab [title]="'Selected SKU Locations'"> </gains-tab>
  </gains-tabset> -->

  <div class="sku-locations-grid">
    <gains-grid
      [rowData]="skuLocations"
      [isExternalFilterPresent]="isExternalFilterPresent"
      [doesExternalFilterPass]="doesExternalFilterPass"
      [customRowSelection]="this.rowSelection"
      [colDefs]="columnDefs"
      [gridOptions]="gridOptions"
        [useDefaultColumnFlex]="false"
      (gridReady)="onGridReady($event)"
      (rowSelected)="onRowSelected($event)"
      (sortChanged)="saveGridState()"
      (filterChanged)="onFilterChanged()"
    >
    </gains-grid>
  </div>
</div>
